import * as type from './type';
export default {
    [type.SET_CURRENT_STEP](state, currentStep) {
        state.currentStep = currentStep;
    },
    [type.CLEAR_COMPANY_INPUT_VALUE](state, inputValue) {
        state.form.companyLicence = Object.assign(state.form.companyLicence, inputValue);
    },
    [type.CLEAR_LEGAL_INPUT_VALUE](state, inputValue) {
        state.form.userLicence = Object.assign(state.form.userLicence, inputValue);
    },
    [type.FILL_COMPANY_TYPE](state, userType){
        state.form.userType = userType;
    },
    [type.UPDATE_INVITATION_CODE_SHOW](state, isShowInvitationCode){
        state.isShowInvitationCode = isShowInvitationCode;
    },
    [type.FILL_INVITATION_CODE](state, invitationCode){
        state.form.invitationCode = invitationCode;
    },
    [type.FILL_COMPANY_INFO](state, companyLicence){
        state.form.companyLicence = Object.assign(state.form.companyLicence, companyLicence);
    },
    [type.FILL_LEGAL_INFO](state, userLicence){
        state.form.userLicence = Object.assign(state.form.userLicence, userLicence);
    },
    [type.FILL_QUALIFY_INFO](state, qualificationInfo){
        state.form.qualificationInfo = Object.assign(state.form.qualificationInfo, qualificationInfo);
    },
    // [type.SET_REGISTER_INFO](state, registerInfo){
    //     // Object.assign是浅拷贝
    //     state.form = Object.assign({}, state.form, registerInfo);
    // },
    [type.SET_PERSONAL_INFO](state, personalInfo){
        state.personalInfo = personalInfo;
    }
}


// WEBPACK FOOTER //
// ./src/store/register/mutations.js